import {
  ETextStyleVariant,
  GeneralHeartFilledIcon,
  GeneralHeartUnfilledIcon,
  RawButton,
  Text,
} from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React, { RefObject } from 'react';
import { useIntl } from 'react-intl';

type TFavoriteToggleButtonProps = {
  iconRef?: RefObject<HTMLDivElement>;
  isFavorite?: boolean;
  favoriteCount?: number;
  hideFavoriteCount?: boolean;
  onClick: () => void;
};

export const FavoriteToggleButton = ({
  iconRef,
  isFavorite,
  favoriteCount = 0,
  hideFavoriteCount,
  onClick,
}: TFavoriteToggleButtonProps) => {
  const intl = useIntl();

  return (
    <div className="relative">
      <RawButton
        onPress={onClick}
        onClickCapture={e => e.preventDefault()}
        aria-label={
          isFavorite
            ? intl.formatMessage({ defaultMessage: 'Saved', id: 'fsB/4p' })
            : intl.formatMessage({ defaultMessage: 'Click to save', id: 'q+y0s3' })
        }>
        <div className="flex items-center text-white gap-1 flex-nowrap">
          {!hideFavoriteCount && favoriteCount > 0 && (
            <Text component="div" variant={ETextStyleVariant.LargeRegular}>
              {favoriteCount > 999
                ? intl.formatMessage({ defaultMessage: '1K+', id: 'dAHibN' })
                : favoriteCount}
            </Text>
          )}

          <div ref={iconRef} className="relative w-7 h-7">
            <GeneralHeartFilledIcon
              className={cn('text-gray-800 w-full h-full', {
                'opacity-30': !isFavorite,
              })}
            />

            <GeneralHeartUnfilledIcon className="absolute inset-0 w-full h-full" />
          </div>
        </div>
      </RawButton>
    </div>
  );
};
